export interface IUseLocalStorageExports {
    setItemStorage: (key: string, value: string) => void;
    eventListenerStorage: (key: string, value: string, action: () => void) => void;
    removeEventListenerStorage: (key: string, value: string, action: () => void) => void;
}

export const useLocalStorageEvents = (): IUseLocalStorageExports => {
    const setItemStorage = (key: string, value: string) => {
        window.localStorage.setItem(key, value);
    };
    const listener = (event: StorageEvent, key: string, value: string, action: () => void) => {
        if (event.storageArea != localStorage) return;
        if (event.key === key && event.newValue === value) {
            action();
        }
    };
    const eventListenerStorage = (key: string, value: string, action: () => void) => {
        window.addEventListener('storage', (event: StorageEvent) => listener(event, key, value, action));
    };
    const removeEventListenerStorage = (key: string, value: string, action: () => void) => {
        window.removeEventListener('storage', (event: StorageEvent) => listener(event, key, value, action));
    };

    return {
        setItemStorage,
        eventListenerStorage,
        removeEventListenerStorage,
    };
};
